import HargaSatuanRataRataPenyusutan from './HargaSatuanRataRataPenyusutan'

export default HargaSatuanRataRataPenyusutan